import { useTranslation } from "react-i18next";

import { Arrange, Pill } from "@aviary";
import type { AllergenSplinter } from "@clinic/shared/data/queries/ProductByIdQuery/ProductById.query";
import { l } from "@emerson/locales";

import { GenericCollapsible } from "../GenericCollapsible/GenericCollapsible";

interface Props {
  allergens: AllergenSplinter[];
}

const DietaryConsiderations = ({ allergens }: Props) => {
  const { t } = useTranslation();

  if (allergens?.length === 0) return null;

  return (
    <GenericCollapsible header={t(l.productDetails.DietaryConsiderations)}>
      <Arrange spacing="xsmall">
        {allergens?.map(allergen => (
          <Pill isColor="system" size="small" key={allergen.id} data-testid="allergen">
            {allergen.name}
          </Pill>
        ))}
      </Arrange>
    </GenericCollapsible>
  );
};

export { DietaryConsiderations };
